import { render } from "./OrdersSkeleton.vue?vue&type=template&id=7f8e9963&scoped=true"
import script from "./OrdersSkeleton.vue?vue&type=script&lang=js"
export * from "./OrdersSkeleton.vue?vue&type=script&lang=js"

import "./OrdersSkeleton.vue?vue&type=style&index=0&id=7f8e9963&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8e9963"]])

export default __exports__